/// <reference types="vite/client" />

import { createEnvConfig } from "@ews-admin/global-design-system";

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const envConfig = createEnvConfig(import.meta.env.VITE_ENV, {
  ...(import.meta.env.VITE_MEDECINE360_BFF_URL && {
    bffUrl: import.meta.env.VITE_MEDECINE360_BFF_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_LOGIN_BFF_URL && {
    loginBffUrl: import.meta.env.VITE_MEDECINE360_LOGIN_BFF_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_APP_URL && {
    appUrl: import.meta.env.VITE_MEDECINE360_APP_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_LOGIN_URL && {
    loginUrl: import.meta.env.VITE_MEDECINE360_LOGIN_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_DASHBOARD_URL && {
    dashboardUrl: import.meta.env.VITE_MEDECINE360_DASHBOARD_URL,
  }),
  ...(import.meta.env.VITE_MEDECINE360_ADMIN_URL && {
    adminUrl: import.meta.env.VITE_MEDECINE360_ADMIN_URL,
  }),
});

export const getLoginApplicationUrl = (redirectTo?: string) => {
  const baseUrl = envConfig.loginUrl;
  if (redirectTo) {
    const url = new URL(baseUrl);
    url.searchParams.set("redirectTo", redirectTo);
    return url.toString();
  }
  return baseUrl;
};

export const getApplicationUrl = () => envConfig.appUrl;
export const getApplicationApiUrl = () => envConfig.bffUrl;
export const getLoginApiUrl = () => envConfig.loginBffUrl;
/**
 * MED-1482: the admin's own origin, per environment. Used as the `redirectTo`
 * handed to the login application so an administrator comes back to the admin
 * after re-authenticating instead of landing on the dashboard app.
 */
export const getAdminUrl = () => envConfig.adminUrl;

export const getFieldsErrorMessage = (
  fields: { name: string; message: string }[]
): string => {
  return fields.map(field => `${field.name}: ${field.message}`).join(", ");
};

export const PHONE_REGEX =
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
